import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

export default function AppDatePicker({
    label = '"year", "month" and "day"',
    value,
    onChange,
    disabled = false,
    required = false,
    size = 'small',
    fullWidth = true,
    minDate,
    maxDate,
    name,
    id,
    className = '',
    sx = {},
    slotProps = {}
}) {
    const parsedValue = value && dayjs(value).isValid() ? (dayjs.isDayjs(value) ? value : dayjs(value)) : null;

    const handleChange = (newValue) => {
        const formatted = newValue && dayjs.isDayjs(newValue) && newValue.isValid()
            ? newValue.format('YYYY-MM-DD')
            : (newValue && dayjs(newValue).isValid() ? dayjs(newValue).format('YYYY-MM-DD') : '');

        if (onChange) {
            // Also provide synthetic event so both onChange(val) and onChange(e) / e.target.value work
            const syntheticEvent = { target: { value: formatted, name, id } };
            onChange(formatted, syntheticEvent);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label}
                views={['year', 'month', 'day']}
                format="DD/MM/YYYY"
                value={parsedValue}
                onChange={handleChange}
                disabled={disabled}
                minDate={minDate ? (dayjs.isDayjs(minDate) ? minDate : dayjs(minDate)) : undefined}
                maxDate={maxDate ? (dayjs.isDayjs(maxDate) ? maxDate : dayjs(maxDate)) : undefined}
                slotProps={{
                    textField: {
                        size,
                        fullWidth,
                        required,
                        id,
                        name,
                        className: `bg-white ${className}`,
                        sx: {
                            backgroundColor: '#fff',
                            borderRadius: '4px',
                            ...sx
                        },
                        ...slotProps.textField
                    },
                    ...slotProps
                }}
            />
        </LocalizationProvider>
    );
}

